import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject, forkJoin } from 'rxjs';
import { ModalService } from './../../../../../services/modal.service';
import { AlertService } from './../../../../../services/alert.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ObjetivoService } from '../../../services/objetivo.service';
import { RiesgosService } from '../../../services/riesgos.service';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { Riesgos } from '../../../models/riesgos';
import { EquipoGerencialService } from 'src/app/modulos/catalogos-proces/services/equipo.gerencial.service';
import { ParticipanteElementoService } from '../../../services/participante.elemento.service';
import { DatePipe } from '@angular/common';
import { AccionService } from '../../../services/accion.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { map } from 'rxjs/operators';
import { PlanesInstitucionalesAnualesService } from 'src/app/modulos/catalogos-admin/services/planes-institucionales-anuales.service';
import { UsuarioRedux } from 'src/app/models/usuario.model';

@Component({
  selector: 'app-riesgo-objetivo',
  templateUrl: './riesgo-objetivo.component.html',
  styleUrls: ['./riesgo-objetivo.component.css']
})
export class RiesgoObjetivoComponent implements OnInit, OnDestroy {
  public formRiesgo: UntypedFormGroup;
  public currentUserRedux: UsuarioRedux = null;
  public submitted = false;
  public dataProcesosIndicadores: any = [];
  public dataObjetivo: any = [];
  private idDeleteRegister: number = 0;
  private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  public nameModalRiesgoObjetivo: string = 'modalRiesgoObjetivo';
  public nameModalGestionRO: string = 'modalGestionRO'
  public nameApp = 'Riesgos de Objetivos';
  public nameAppGestionRO = 'Acciones de Riesgos';
  public selectItems: any = [];
  public itemEstadoRiesgo: any = [];
  public idSprAmbiente: number = 0;
  public idSprAnio: number = 0;
  public idSprPlanAnio: number = 0;
  private idSprUsuario: number = 0;
  public dataRiesgo: any[] = [];
  public dataObjetivoRiesgo: any = [];
  public dataCatComun!: any;
  public calificacionTotal!: any;
  public riesgos!: any;
  public idRiesgoSeleccionado: number = 0;
  public idSprNivel: number = 0;
  public idRiesgo!: any;
  public riesgosOutput!: any;
  public dataEquipoGerencial!: any;
  public dataTipoParticpacion: any = [];
  public dataPersonalElemento!: any;
  public dataResponsableProceso: any = [];
  public dataResponsable: any = [];
  public estadoActivo: number = 1;
  pipe = new DatePipe('en-US');
  hoy = new Date();
  public currentAmbiente!: any;
  public dataAccion: any[] = [];
  readonly constant = ConstantsCatalogosIdService;

  idSprEstructuraDesglose = this.constant.ID_COMUNES_ESTRUCTUTA_DESGLOSE;
  idSprTipoParticipante = this.constant.ID_COMUNES_RESPONSABLE;

  public elementoActual = "";
  public objetivoPadre = null;
  public dataObjetivos = ""
  public dataPlanesAnios: any = null;
  public nameElemento!: any;

  //Variable que almacena el plan Años seleccionado
  public planAnioSeleccionadoRedux: any = null;

  @Input() set init(objetivo: any) {
    this.nameElemento = objetivo
    //this.ngOnInit();
  }

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;

  constructor(
    public modal: ModalService,
    private ip: IpPublicService,
    private alert: AlertService,
    private fb: FormBuilder,
    private objetivoService: ObjetivoService,
    private riesgoService: RiesgosService,
    private planAniosService: PlanesInstitucionalesAnualesService,
    private catalogoComunService: ComunService,
    private equipoGerencialService: EquipoGerencialService,
    private participanteElementoService: ParticipanteElementoService,
    private accionService: AccionService,
    public store: Store<AppState>
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.currentAmbiente = JSON.parse(this.buffer);
    this.selectItems = [
      { value: '', label: 'Selecione..' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];

    this.itemEstadoRiesgo = [
      { value: '', label: 'Selecione..' },
      { value: 1, label: 'Abierto' },
      { value: 2, label: 'Cerrado' },
    ];

    this.idSprAmbiente = this.currentUser.idSprAmbiente;
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  get appForm() {
    return this.formRiesgo.controls;
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }
  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  ngOnInit(): void {
    this.store.select("globalApp").subscribe((response) => {// redux
      this.planAnioSeleccionadoRedux = response.planAniosSeleccionado;
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
      this.idSprAnio = response.planAniosSeleccionado.idSprAnio;
      this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio;
      this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
      this.initApp();
    });

    this.store.select('usuarioApp').subscribe((response) => {
      this.currentUserRedux = response.currentUser;
      this.idSprUsuario = response.currentUser.idSprUsuario;
    });
  }

  initApp() {
    if (this.nameElemento == 'objetivo') {
      this.listPlanAnios();
      this.listEquipoGerencial();
    }
    this.getIpPublic();
    this.setDataTable();
    this.getDataCatalogoComun();
    this.setFromObjetivo(this.dataObjetivos);
  }

  listPlanAnios() {
    this.planAniosService.list('?idSprPlanAnio=' + this.idSprPlanAnio).subscribe({
      next: (resp) => {
        this.dataPlanesAnios = resp;
        this.getDataAll(this.idSprPlanAnio);
      }
    })
  }

  getDataAll(idSprPlanAnioSelected: number) {
    forkJoin([
      this.objetivoService.list('?idSprAmbiente=' + this.idSprAmbiente + '&idSprPlanAnio=' + idSprPlanAnioSelected + '&estado=' + this.estadoActivo),
      this.riesgoService.list(),
      this.participanteElementoService.list(),
      this.equipoGerencialService.list(),
      this.accionService.list()
    ]).pipe(map(
      ([dataObjetivo, dataRiesgo, dataPersonalElemento, dataEquipoGerencial, dataAccion]) => {
        this.dataObjetivo = dataObjetivo;
        this.dataRiesgo = dataRiesgo;
        this.dataPersonalElemento = dataPersonalElemento;
        this.dataEquipoGerencial = dataEquipoGerencial;
        this.dataAccion = dataAccion;
        this.mapeoObjetivoRiesgo();
      })).subscribe();
  }


  mapeoObjetivoRiesgo() {
    let indiceUno = 0;
    let dataObjetivoRiesgoMap: any = [];
    let dataRiesgosMap: any = [];
    for (let i = 0; i < this.dataObjetivo.length; i++) {
      for (let j = 0; j < this.dataRiesgo.length; j++) {
        if (this.dataObjetivo[i].idSprObjetivo == this.dataRiesgo[j].idSprObjetivo) {
          for (let k = 0; k < this.dataPersonalElemento.length; k++) {
            if (this.dataPersonalElemento[k].idSprRiesgo == this.dataRiesgo[j].idSprRiesgo) {
              for (let l = 0; l < this.dataEquipoGerencial.length; l++) {
                if ((this.dataEquipoGerencial[l].idSprEquipoGerencial == this.dataPersonalElemento[k].idSprEquipoGerencial)) {
                  dataRiesgosMap.push({
                    idSprObjetivo: this.dataObjetivo[i].idSprObjetivo,
                    nameObjetivo: this.dataObjetivo[i].nombre,
                    idSprRiesgo: this.dataRiesgo[j].idSprRiesgo,
                    nombre: this.dataRiesgo[j].nombre,
                    descripcion: this.dataRiesgo[j].descripcion,
                    probabilidad: this.dataRiesgo[j].probabilidad,
                    impacto: this.dataRiesgo[j].impacto,
                    calificacion: this.dataRiesgo[j].calificacion,
                    costoPotencial: this.dataRiesgo[j].costoPotencial,
                    idSprEstructuraEdr: this.dataRiesgo[j].idSprEstructuraEdr,
                    fechaIdentificacion: this.dataRiesgo[j].fechaIdentificacion,
                    fechaOcurrencia: this.dataRiesgo[j].fechaOcurrencia,
                    fechaCierre: this.dataRiesgo[j].fechaCierre,
                    estadoRiesgo: this.dataRiesgo[j].estadoRiesgo,
                    estado: this.dataRiesgo[j].estado,
                    fecha: this.dataRiesgo[j].fecha,
                    idSprEquipoGerencial: this.dataEquipoGerencial[l].idSprEquipoGerencial,
                    gradoNombres: this.dataEquipoGerencial[l].gradoNombres,
                    idSprParticipanteElemento: this.dataPersonalElemento[k].idSprParticipanteElemento
                  }); indiceUno++;
                }
              }
            }
          }
        }
      }
      dataObjetivoRiesgoMap.push({
        nameObjetivo: this.dataObjetivo[i].nombre,
        idSprObjetivo: this.dataObjetivo[i].idSprObjetivo,
        fechaInicio: this.dataObjetivo[i].fechaInicio,
        fechaFin: this.dataObjetivo[i].fechaFin,
        riesgos: dataRiesgosMap
      }); dataRiesgosMap = [];
    }
    this.dataObjetivoRiesgo = dataObjetivoRiesgoMap
  }


  setFromObjetivo(dataObjetivos: any) {
    let idSprObjetivo = null;
    let fechaInicio = null;
    let fechaFin = null;
    idSprObjetivo = dataObjetivos.idSprObjetivo
    fechaInicio = dataObjetivos.fechaInicio
    fechaFin = dataObjetivos.fechaFin


    this.formRiesgo = this.fb.group({
      idSprObjetivo: [idSprObjetivo],
      idSprRiesgo: [],
      idSprEstructuraEdr: ['', [Validators.required]],
      idSprEquipoGerencialAnterior: ['', []],
      idSprParticipanteElemento: ['', []],
      idSprEquipoGerencial: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      descripcion: ['', [Validators.required]],
      fechaIdentificacion: ['', [Validators.required, validadorFechaIntervalo(fechaInicio, fechaFin)]],
      probabilidad: ['', [Validators.required]],
      impacto: ['', [Validators.required]],
      calificacion: [],
      costoPotencial: ['', [Validators.required]],
      fechaOcurrencia: ['', [Validators.required, validadorFechaIntervalo(fechaInicio, fechaFin)]],
      fechaCierre: ['', [Validators.required, validadorFechaIntervalo(fechaInicio, fechaFin)]],
      estadoRiesgo: ['', [Validators.required]],
      estado: ['', [Validators.required]],
    });
  }

  validacionFechas(fecha1: Date, fecha2: Date, fecha3: Date) {
    let alerta1
    let alerta2
    if (fecha1 > fecha2) {
      alerta1 = this.alert.warning(
        'Atención!',
        'La fecha IDENTIFICACIÓN no puede ser mayor a la fecha OCURRENCIA'
      );
      return alerta1
    }
    if (fecha2 > fecha3) {
      alerta2 = this.alert.warning(
        'Atención!',
        'La fecha OCURRENCIA no puede ser mayor a la fecha CIERRE'
      );
      return alerta2
    }
  }

  onSubmit() {
    let stateInsert: boolean = false;
    let idSprRiesgoInsertado: number = 0;
    this.submitted = true;
    this.formRiesgo.value.usuario = this.idSprUsuario;
    this.formRiesgo.value.ip = this.ipAddress;
    this.calificacionTotal = this.calificacion();
    this.formRiesgo.value.calificacion = this.calificacionTotal;
    let fechaIdentificacion = this.formRiesgo.value.fechaIdentificacion;
    let fechaOcurrencia = this.formRiesgo.value.fechaOcurrencia;
    let fechaCierre = this.formRiesgo.value.fechaCierre;
    this.validacionFechas(fechaIdentificacion, fechaOcurrencia, fechaCierre);
    if (!this.formRiesgo.invalid && (fechaIdentificacion <= fechaOcurrencia) && (fechaOcurrencia <= fechaCierre)) {
      if (this.formRiesgo.value.idSprRiesgo == null) {
        this.riesgoService.create(this.formRiesgo.value).subscribe(
          (resp) => {
            stateInsert = true;
            idSprRiesgoInsertado = resp.idSprRiesgo;

            let dataParticpante = {
              idSprEquipoGerencial: this.formRiesgo.value.idSprEquipoGerencial,
              fechaInicio: this.pipe.transform(this.hoy, 'yyyy-MM-dd'),
              usuario: this.idSprUsuario,
              idSprRiesgo: idSprRiesgoInsertado,
              estado: 1,
              ip: this.ipAddress,
            }
            if (stateInsert) {
              this.participanteElementoService.create(dataParticpante).subscribe(responseParticipaELement => {
                stateInsert = true;
              },
                (error) => {
                  stateInsert = false;
                });
            }
            this.initApp();
            this.modal.close();
            this.alert.createOk();

          },
          (err) => {
            this.alert.createError();
          }
        );
      } else {
        this.riesgoService.update(this.formRiesgo.value).subscribe(
          (resp) => {
            if (this.formRiesgo.value.idSprEquipoGerencial != this.formRiesgo.value.idSprEquipoGerencialAnterior) {
              let estadoParticipante: boolean = true;
              if (this.formRiesgo.value.idSprEquipoGerencialAnterior != null) {
                let dataParticipanteELemento = {
                  idSprParticipanteElemento: this.formRiesgo.value.idSprParticipanteElemento,
                  fechaFin: this.pipe.transform(this.hoy, 'yyyy-MM-dd'),
                  usuario: this.idSprUsuario,
                  estado: 2,
                  ip: this.ipAddress,
                }
                this.participanteElementoService.update(dataParticipanteELemento).subscribe(responseParticipaELement => {
                },
                  (error) => {
                    estadoParticipante = false;
                    stateInsert = false;
                  });
              }
              if (estadoParticipante) {
                let dataParticipElemento = {
                  idSprEquipoGerencial: this.formRiesgo.value.idSprEquipoGerencial,
                  fechaInicio: this.pipe.transform(this.hoy, 'yyyy-MM-dd'),
                  usuario: this.idSprUsuario,
                  idSprRiesgo: this.formRiesgo.value.idSprRiesgo,
                  estado: 1,
                  ip: this.ipAddress
                }
                this.participanteElementoService.create(dataParticipElemento).subscribe(responseParticipaELement => {
                },
                  (error) => {
                    stateInsert = false;
                  });
              }// Fin insertar participante
            }
            this.initApp()
            this.modal.close();
            this.alert.updateOk();
          },
          (err) => {
            this.alert.updateError();
          }
        );
      }
    } else {
    }
  }

  delete(id: number) {
    this.idDeleteRegister = id;
    this.modal.open('del');
  }

  confirmDelete() {
    if (this.idDeleteRegister > 0) {
      this.accionService.list(`?idSprRiesgo=${this.idDeleteRegister}&delLog=N`)
        .subscribe(response => {
          if (response.length < 1) {
            let errorDeleteState: boolean = false;
            let dataDeleteParticipElementos = {
              usuario: this.idSprUsuario,
              idSprParticipanteElemento: 0,
              ip: this.ipAddress,
              delLog: 'S'
            }
            let dataDeleteProceso = {
              idSprRiesgo: this.idDeleteRegister,
              usuario: this.idSprUsuario,
              ip: this.ipAddress,
              delLog: 'S'
            }
            if (this.idDeleteRegister > 0) {
              let participantesElementos = [];
              this.participanteElementoService.list(`?idSprRiesgo=${this.idDeleteRegister}`).subscribe(response => {
                participantesElementos = response;
                // Foreach 2
                participantesElementos.forEach(itemParticipanteElement => {
                  dataDeleteParticipElementos.idSprParticipanteElemento = itemParticipanteElement.idSprParticipanteElemento;
                  this.participanteElementoService.delete(dataDeleteParticipElementos).subscribe({
                    next: responseDelete => {
                      this.riesgoService.delete(dataDeleteProceso).subscribe({
                        next: responseDelete => {
                          this.initApp();
                        },
                        error: (error) => {
                          errorDeleteState = true;
                        }
                      })
                    },
                    error: (error) => {
                      errorDeleteState = true;
                      dataDeleteProceso.delLog = 'N';
                      this.riesgoService.delete(dataDeleteProceso).subscribe({
                        next: responseDelete => {
                        },
                        error: (error) => {
                          errorDeleteState = true;
                        }
                      })
                    }
                  })
                });// Fin forEach 2
              });
            }
            if (!errorDeleteState) {
              this.reDrawDataTable();
              this.initApp()
              this.setDataTable();
              this.alert.deleteOk();
              this.modal.close();
            } else {
              this.alert.deleteError();
            }
          } else {
            this.alert.warning('Atención!', "No se puede borrar este registro, existe ACCIONES relacionadas!")
            this.modal.close();
          }
        });
    } else {
      this.alert.warning('Atención!', "Ocurrió un error al intentar borrar el registro");
      this.modal.close();
    }
  }

  edit(obj: Riesgos) {
    this.elementoActual = obj.nameObjetivo;
    this.formRiesgo.patchValue({
      idSprObjetivo: obj.idSprObjetivo,
      idSprRiesgo: obj.idSprRiesgo,
      idSprEstructuraEdr: obj.idSprEstructuraEdr,
      idSprEquipoGerencial: obj.idSprEquipoGerencial,
      idSprEquipoGerencialAnterior: obj.idSprEquipoGerencial,
      idSprParticipanteElemento: obj.idSprParticipanteElemento,
      nombre: obj.nombre,
      descripcion: obj.descripcion,
      fechaIdentificacion: obj.fechaIdentificacion,
      probabilidad: obj.probabilidad,
      impacto: obj.impacto,
      calificacion: obj.calificacion,
      costoPotencial: obj.costoPotencial,
      fechaOcurrencia: obj.fechaOcurrencia,
      fechaCierre: obj.fechaCierre,
      estadoRiesgo: obj.estadoRiesgo,
      estado: obj.estado,
    });
    this.modal.open(this.nameModalRiesgoObjetivo);
  }

  getDataCatalogoComun() {
    this.catalogoComunService.list('?spr_idSprComun=' + this.idSprEstructuraDesglose)
      .subscribe(resp => {
        this.dataCatComun = resp;
      })
  }

  getDataDependiente(dataObj: any, spr_idSprComun: any = null) {
    let stateOptionTipo = false;
    let dependientes: any = [];
    dataObj.forEach((row: any) => {
      if (row.spr_idSprComun == spr_idSprComun) {
        dependientes.push(
          {
            idSprComun: row.idSprComun,
            nombre: row.nombre,
            descripcion: row.descripcion,
            spr_idSprComun: row.spr_idSprComun,
            estado: row.estado,
          });
      }
    });
    return dependientes;
  }

  calificacion() {
    let probabilidad: any;
    let impacto: any;
    let totalCalificacion: any;
    probabilidad = this.formRiesgo.value.probabilidad;
    impacto = this.formRiesgo.value.impacto;
    totalCalificacion = (probabilidad * impacto) / 100;
    return totalCalificacion;
  }
  /********************************** EQUIPO GERENCIAL************************************/
  listEquipoGerencial() {
    this.equipoGerencialService.list(`?idSprAmbiente=${this.idSprAmbiente}&idSprTipoParticipante=${this.idSprTipoParticipante}&estado=${1}`)
      .subscribe((resp) => {
        this.dataResponsable = resp;
      });
  }

  getTipoParticipacion() {
    this.catalogoComunService.list().subscribe(respTipoParticipa => {
      this.dataTipoParticpacion = respTipoParticipa;
      this.mapeoEquipoGerencialTipoParticipa();
    })
  }

  mapeoEquipoGerencialTipoParticipa() {
    let dataProcess = [];
    for (let i = 0; i < this.dataEquipoGerencial.length; i++) {
      for (let j = 0; j < this.dataTipoParticpacion.length; j++) {
        if ((this.dataEquipoGerencial[i].idSprTipoParticipante === this.dataTipoParticpacion[j].idSprComun) && (this.dataEquipoGerencial[i].estado == 1)) {
          dataProcess.push({
            idSprEquipoGerencial: this.dataEquipoGerencial[i].idSprEquipoGerencial,
            nombres: this.dataEquipoGerencial[i].gradoNombres,
            cedula: this.dataEquipoGerencial[i].cedula,
            participacion: this.dataTipoParticpacion[j].nombre
          })
        }
      }
    }
    this.dataResponsableProceso = dataProcess;
  }

  /********************CONTADOR DE CARACTER*******************/
  public contador = 0
  onKey(event) {
    let maxLength = 3000;
    let strLength = event.target.value.length;
    let charRemain = (maxLength - strLength);
    if (charRemain < 0) {
      document.getElementById("contador").innerHTML = '<span style="color: red;"> Ha superado el límite de ' + maxLength + ' characters</span>';
    } else {
      document.getElementById("contador").innerHTML = charRemain + ' caracteres restantes';
    }
  }
  /*************************************************************/

  numeroAcciones(idSprRiesgo: any) {
    let dataIdSprRiesgo = {
      idSprRiesgo: idSprRiesgo
    }
  }

  openModal(row: any) {
    this.elementoActual = row.nameObjetivo;
    this.submitted = false
    this.formRiesgo.reset();
    this.setFromObjetivo(row);
    this.modal.open(this.nameModalRiesgoObjetivo);

  }
  openModalGestion(row: any) {
    this.onResetForm();
    this.idRiesgoSeleccionado = row
    this.modal.open(this.nameModalGestionRO);
  }

  onResetForm() {
    this.submitted = false;
    this.formRiesgo.reset();
  }

}
